<script lang="ts">
import './Icons.css'

import { defineComponent } from 'vue-demi'

export default defineComponent({
  props: {
    width: {type: Number, required: true},
    height: {type: Number, required: true},
  },
  data() {
    return {}
  },
  methods: {},
})
</script>

<template>
  <div
    role="presentation"
    class="icon-component icon-component-settings"
    :style="{ width: `${width}px`, height: `${height}px` }"
  >
    <svg
      :width="width"
      :height="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6504_32875)">
        <path
          d="M11.1514 2.75H12.8486C14.7918 2.75 16.1705 2.75217 17.2158 2.89941C18.2357 3.04313 18.8278 3.31176 19.2637 3.76855C19.7043 4.23035 19.9671 4.86511 20.1064 5.95117C20.2481 7.05551 20.25 8.50913 20.25 10.543V14.9756C20.25 16.737 20.2489 18.0091 20.1689 18.9434C20.0867 19.9043 19.9296 20.3326 19.7559 20.542C19.346 21.0359 18.7496 21.2891 18.1484 21.2451C17.9082 21.2275 17.5237 21.0559 16.8174 20.4375C16.1329 19.8382 15.276 18.9416 14.0869 17.6953C13.8233 17.419 13.5939 17.1774 13.3896 16.9961C13.1795 16.8096 12.944 16.6384 12.6494 16.54C12.2272 16.3992 11.7728 16.3992 11.3506 16.54C11.056 16.6384 10.8205 16.8096 10.6104 16.9961C10.4061 17.1774 10.1767 17.419 9.91309 17.6953C8.72403 18.9416 7.86709 19.8382 7.18262 20.4375C6.47634 21.0559 6.09181 21.2275 5.85156 21.2451C5.25042 21.2891 4.65396 21.0359 4.24414 20.542C4.07042 20.3326 3.91327 19.9043 3.83105 18.9434C3.75112 18.0091 3.75 16.737 3.75 14.9756V10.543C3.75 8.50913 3.75189 7.05551 3.89355 5.95117C4.0329 4.86511 4.29572 4.23035 4.73633 3.76855C5.17223 3.31176 5.76427 3.04313 6.78418 2.89941C7.82947 2.75217 9.20824 2.75 11.1514 2.75Z"
          stroke="white"
          stroke-width="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_6504_32875">
          <rect
            :width="width"
            :height="height"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>
